/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportGetYoutubeCategoriesQueryResponse, SocialExportGetYoutubeCategoriesPathParams, SocialExportGetYoutubeCategories400, SocialExportGetYoutubeCategories401, SocialExportGetYoutubeCategories403, SocialExportGetYoutubeCategories404 } from "../models/SocialExportGetYoutubeCategories";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { socialExportGetYoutubeCategories } from "../axios/socialExportGetYoutubeCategories";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const socialExportGetYoutubeCategoriesQueryKey = (connectionId: SocialExportGetYoutubeCategoriesPathParams["connectionId"]) => ["api-v2", { url: '/social-export/v1/platforms/youtube/:connectionId/categories', params: {connectionId:connectionId} }] as const

export type SocialExportGetYoutubeCategoriesQueryKey = ReturnType<typeof socialExportGetYoutubeCategoriesQueryKey>

export function socialExportGetYoutubeCategoriesQueryOptions(connectionId: SocialExportGetYoutubeCategoriesPathParams["connectionId"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = socialExportGetYoutubeCategoriesQueryKey(connectionId)
        return queryOptions<SocialExportGetYoutubeCategoriesQueryResponse, ResponseErrorConfig<SocialExportGetYoutubeCategories400 | SocialExportGetYoutubeCategories401 | SocialExportGetYoutubeCategories403 | SocialExportGetYoutubeCategories404>, SocialExportGetYoutubeCategoriesQueryResponse, typeof queryKey>({
         enabled: !!(connectionId),
         queryKey,
         queryFn: async ({ signal }) => {
            return socialExportGetYoutubeCategories(connectionId, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns available YouTube video categories based on the client country code. Returns an empty array when the client has no country code.
 * @summary Get YouTube video categories for a connection
 * {@link /social-export/v1/platforms/youtube/:connectionId/categories}
 */
export function useSocialExportGetYoutubeCategories<TData = SocialExportGetYoutubeCategoriesQueryResponse, TQueryData = SocialExportGetYoutubeCategoriesQueryResponse, TQueryKey extends QueryKey = SocialExportGetYoutubeCategoriesQueryKey>(connectionId: SocialExportGetYoutubeCategoriesPathParams["connectionId"], options: 
{
  query?: Partial<QueryObserverOptions<SocialExportGetYoutubeCategoriesQueryResponse, ResponseErrorConfig<SocialExportGetYoutubeCategories400 | SocialExportGetYoutubeCategories401 | SocialExportGetYoutubeCategories403 | SocialExportGetYoutubeCategories404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? socialExportGetYoutubeCategoriesQueryKey(connectionId)
         

         const query = useQuery({
          ...socialExportGetYoutubeCategoriesQueryOptions(connectionId, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<SocialExportGetYoutubeCategories400 | SocialExportGetYoutubeCategories401 | SocialExportGetYoutubeCategories403 | SocialExportGetYoutubeCategories404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}